<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="search-wrapper">
    <mat-form-field class="no-label">
        <input matInput [formControl]="search" placeholder="Caută">
        <nb-icon icon="search" matPrefix class="icon-search"></nb-icon>
        <nb-icon matSuffix icon="close-outline" *ngIf="showClear && value" (click)="clear()" class="clear-icon"></nb-icon>
    </mat-form-field>
</div>
